import { render, staticRenderFns } from "./MarketingConsent.vue?vue&type=template&id=3f9de18c&"
import script from "./MarketingConsent.vue?vue&type=script&lang=js&"
export * from "./MarketingConsent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports